import React from "react";

/**
 * Benova brand logo as pure typography — no background, scales cleanly.
 * Props:
 *   color: text color (defaults to current text color via "currentColor")
 *   accent: subtitle color (TRAVEL GROUP line). Defaults to currentColor with reduced opacity.
 *   size: "sm" | "md" | "lg" | "xl"  (affects font sizes)
 *   className: passthrough wrapper class
 */
export default function BenovaLogo({ color = "currentColor", accent, size = "md", className = "" }) {
  const sizes = {
    sm: { main: ".75rem", sub: ".42rem", gap: "2px" },
    md: { main: "1.05rem", sub: ".5rem", gap: "3px" },
    lg: { main: "1.6rem", sub: ".62rem", gap: "5px" },
    xl: { main: "2.4rem", sub: ".82rem", gap: "7px" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div
      className={`inline-flex flex-col leading-none ${className}`}
      style={{ color }}
      aria-label="Benova Travel Group"
    >
      <span
        style={{
          fontFamily: "var(--bn-font-heading, Georgia, 'Times New Roman', serif)",
          fontWeight: 400,
          fontSize: s.main,
          letterSpacing: "0.22em",
          lineHeight: 1,
        }}
      >
        BENOVA
      </span>
      <span
        style={{
          fontFamily: "var(--bn-font-sans, 'Helvetica Neue', Arial, sans-serif)",
          fontSize: s.sub,
          letterSpacing: "0.45em",
          marginTop: s.gap,
          opacity: accent ? 1 : 0.75,
          color: accent || "inherit",
          textTransform: "uppercase",
        }}
      >
        Travel Group
      </span>
    </div>
  );
}
